import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StationContextService } from '../services/station-context.service';

export const stationContextGuard: CanActivateFn = () => {
  const stationContext = inject(StationContextService);
  const router = inject(Router);

  if (stationContext.currentStation()) {
    return true;
  }
  return router.parseUrl('/route-stations');
};
